import { useMemo } from 'react'

import { SortableContext, useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { BlockContent } from '~/components'

import { Column, Task } from '../types/Categorization.type'

import TaskCard from './TaskCard'

interface Props {
  column: Column
  tasks: Task[]
  needTitle?: boolean
}

function ColumnContainer({ column, tasks, needTitle = true }: Props): React.ReactElement {
  const tasksIds = useMemo(() => {
    return tasks.map((task) => task.id)
  }, [tasks])

  const { setNodeRef, transform, transition } = useSortable({
    id: column.id,
    data: {
      type: 'Column',
      column,
    },
    disabled: false,
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }

  const isBlock =
    column.categoryName &&
    Array.isArray(column.categoryName) &&
    column.categoryName?.some((block) => block._type === 'block')

  const blockClassName = isBlock ? 'text-[clamp(18px,2vw,22px)]' : 'md:scale-125'
  return (
    <div
      className="bg-white md:min-w-64 min-h-96 h-full rounded-md flex flex-col justify-stretch w-full"
      ref={setNodeRef}
      style={style}
    >
      {needTitle && (
        <div className="bg-white md:min-w-86 pb-0.5 text-center flex items-center justify-between">
          <BlockContent
            blocks={column.categoryName}
            className={`text-center w-full ${blockClassName}`}
            renderContainerOnSingleChild
          />
        </div>
      )}

      <div
        className={`flex flex-col gap-3 p-2   ${
          needTitle ? 'h-96 overflow-y-auto mt-auto' : 'h-24 md:h-26 overflow-hidden'
        } border-purple border-4 rounded`}
      >
        <SortableContext items={tasksIds}>
          {tasks.map((task) => (
            <TaskCard key={task.id} task={task} />
          ))}
        </SortableContext>
      </div>
    </div>
  )
}

export default ColumnContainer
